"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type DeleteVersionsRequest } from "@/generated/fastapi";
import { deleteVersions } from "../api/deleteVersions";
import { versioningKeys } from "../queries/keys";

export default function useDeleteVersionsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: DeleteVersionsRequest) =>
      deleteVersions(accessToken, request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: versioningKeys.all }),
  });
}
